import { useState } from 'react';
import useSWR from 'swr';
import { useDebounce } from 'use-debounce';
// api
import getZipcodes from 'modules/emergencies/api/getZipcodes';

// returns selectedFilters and functions to update them
const usePostalCodeFilter = ({ stop, country, initialQuery = '' }) => {
  const initialSelectedFilters = {
    search: initialQuery,
    country: country,
  };

  const [internalSelectedFilters, setInternalSelectedFilters] = useState(initialSelectedFilters);
  const [selectedFilters] = useDebounce(internalSelectedFilters, 500);

  const filtersKey = JSON.stringify(selectedFilters);
  const { data: zipcodes, error: zipcodeError } = useSWR(
    `/zipcodes/${filtersKey}`,
    () => getZipcodes(internalSelectedFilters),
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingUsersToAssign = typeof zipcodes === 'undefined' && !zipcodeError;
  let zipcodeOptions = [];
  if (zipcodes) {
    zipcodeOptions = (zipcodes?.results || []).map((zipcode) => ({
      value: zipcode.code,
      label: (
        <>
          {zipcode.code} <b>{zipcode.city}</b>
        </>
      ),
      city: zipcode.city,
      display: zipcode.code,
      search: `${zipcode.code} ${zipcode.city}`,
    }));
  }

  const setSearch = (value) => {
    setInternalSelectedFilters({
      ...internalSelectedFilters,
      search: value,
    });
  };

  const setCountry = (value, form) => {
    setInternalSelectedFilters({
      ...internalSelectedFilters,
      country: value,
    });
    form.setFieldValue(`order_data.${stop}.zipcode`, '');
    form.setFieldValue(`order_data.${stop}.country`, value);
  };

  const setZipcode = (value, form, selectedOption) => {
    form.setFieldValue(`order_data.${stop}.zipcode`, value);
    if (selectedOption?.city) {
      form.setFieldValue(`order_data.${stop}.city`, selectedOption.city);
    }
  };

  return {
    internalSelectedFilters,
    zipcodeOptions,
    zipcodeOptionsError: zipcodeError,
    isLoadingZipcodesOptions: isLoadingUsersToAssign,
    setSearch,
    setCountry,
    setZipcode,
  };
};

export default usePostalCodeFilter;
